import { render, staticRenderFns } from "./editCommunityInformation.vue?vue&type=template&id=39122ac0&scoped=true"
import script from "./editCommunityInformation.vue?vue&type=script&lang=js"
export * from "./editCommunityInformation.vue?vue&type=script&lang=js"
import style0 from "./editCommunityInformation.vue?vue&type=style&index=0&id=39122ac0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39122ac0",
  null
  
)

export default component.exports